import { render, staticRenderFns } from "./OthosLinkToTask.vue?vue&type=template&id=5b03dd61&scoped=true"
import script from "./OthosLinkToTask.vue?vue&type=script&lang=js"
export * from "./OthosLinkToTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b03dd61",
  null
  
)

export default component.exports